// extracted by mini-css-extract-plugin
export default {"container":"tooltip_container__lfd9S","overlay":"tooltip_overlay__OIy7w","content":"tooltip_content__yfF0y","target":"tooltip_target__ghhgT"};